import { Currency } from "@goodfill/domain-properties/src";
import { z } from "zod";

export const zCurrency = z.union([z.literal(Currency.USD), z.literal(Currency.JPY)]);

// This is only type-check code to ensure that `zBondsBenchmark` is same as `Benchmark`
const _ = Currency.JPY;
type _Inferred = z.infer<typeof zCurrency>;
type _Reference = Currency;

// It this line has Type-Error it means that the `zBondsBenchmark` is inconsistent with `Benchmark`
((i: _Inferred, r: _Reference) => {})(_ as _Reference, _ as _Inferred);
